
<div
    class="back-general flex align-items-center justify-content-center min-h-screen overflow-hidden"
>
    <div class="flex flex-column align-items-center justify-content-center">
        <div class="header-logo">
            <img src="./assets/AdminAI-color.png" alt="logo" class="flex-shrink-0"/>
            <p>Administraciones y consorcios</p>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>
